const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * A billing date for display: "Nov 14" or, with `withYear`, "Nov 14, 2026".
 * Billing sends some dates as a bare day ("2026-11-14", the renewal and an
 * AppSumo refill) and others as timestamps (a trial's end, a preview's next
 * invoice). A bare day is a calendar day, so it is shown in UTC, the zone it
 * was parsed in; read in local time it would land a day early anywhere west
 * of Greenwich. Timestamps show in the viewer's local time. Null for a
 * missing or unreadable value.
 */
export function formatBillingDate(
  value: string | null | undefined,
  { withYear = false }: { withYear?: boolean } = {}
): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    ...(withYear ? { year: 'numeric' } : {}),
    ...(DATE_ONLY.test(value) ? { timeZone: 'UTC' } : {}),
  }).format(date);
}
